import { render, staticRenderFns } from "./ListPrivacyPolicyView.vue?vue&type=template&id=e35a3996&"
import script from "./ListPrivacyPolicyView.vue?vue&type=script&lang=js&"
export * from "./ListPrivacyPolicyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports